var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"external-link",class:{ padded: _vm.padded },attrs:{"target":_vm.target,"href":_vm.href}},[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('icon',{attrs:{"name":"external","width":"8px","height":"8px"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f10ba1b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/ExternalLink.vue
// module id = null
// module chunks = 